import {
  Channel,
  Chat,
  MessageInput,
  VirtualizedMessageList,
  Thread,
  Window,
} from 'stream-chat-react'
import { Messages } from './Messages'
import { useChatSuport } from '@contexts/ChatSuport'
import { ChatBox } from './styles'
import { CustomMessageInput } from './Input'
import { CustomTypingIndicator } from './CustomTypingIndicator'

export default function Messaging() {
  const { client, channel } = useChatSuport()

  if (!client || !channel) return <div>O Sentinela não está disponível.</div>

  return (
    <ChatBox>
      <Chat client={client} defaultLanguage="pt">
        <Channel
          channel={channel}
          VirtualMessage={Messages}
          TypingIndicator={CustomTypingIndicator}
        >
          <Window>
            {/* <CustomChannelHeader /> */}
            <VirtualizedMessageList
              shouldGroupByUser
              hideNewMessageSeparator
              hideDeletedMessages
              maxTimeBetweenGroupedMessages={2 * 60 * 1000}
            />
            <MessageInput Input={CustomMessageInput} focus />
          </Window>
          <Thread virtualized />
        </Channel>
      </Chat>
    </ChatBox>
  )
}
